module.exports = __webpack_public_path__ + "static/media/standartDoorstep2.c663a04f.png";